// extracted by mini-css-extract-plugin
export default {"departmentsCard":"Odsjeci_departmentsCard__Fzi+s"};